export enum MicroEstimationState {
  ACCRE = 'accre',
  VAT = 'vat',
  COMPANY_SITUATION = 'company-situation',
  PRELEV_LIB = 'prelev-lib',
  INITIAL = 'initial',
  REVENUE_SITUATION = 'revenue-situation',
  SUCCESS = 'success',
  TAX_FREQUENCY = 'tax-frequency',
  TAX_TYPE = 'tax-type',
}
// Should be able to get rid of this separate array after we refactor out the saving states
export const MICRO_ESTIMATION_INCREMENTING_STEPS = [
  MicroEstimationState.TAX_TYPE,
  MicroEstimationState.VAT,
  MicroEstimationState.ACCRE,
  MicroEstimationState.COMPANY_SITUATION,
  MicroEstimationState.PRELEV_LIB,
  MicroEstimationState.REVENUE_SITUATION,
  MicroEstimationState.TAX_FREQUENCY,
  MicroEstimationState.SUCCESS,
] as const;
